// src/components/ReviewCard.jsx
import React from "react";

export default function ReviewCard({ item }) {
  const { name, organization, review, product_name } = item || {};

  return (
    <div className="snap-start shrink-0 w-[85%] sm:w-[420px] rounded-2xl border border-gray-200 bg-white p-5 shadow-sm">
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-sm font-semibold text-gray-900">{name || "Anonymous"}</p>
          <p className="text-xs text-gray-600">{organization || "—"}</p>
        </div>

        {product_name ? (
          <span className="text-[11px] px-2 py-1 rounded-full bg-gray-100 text-gray-700 border border-gray-200">
            {product_name}
          </span>
        ) : null}
      </div>

      <p className="mt-3 text-sm text-gray-700 leading-6">
        “{review || "—"}”
      </p>
    </div>
  );
}
